import script from "./cover-player.vue?vue&type=script&setup=true&lang=ts"
export * from "./cover-player.vue?vue&type=script&setup=true&lang=ts"

import "./cover-player.vue?vue&type=style&index=0&id=bcbeb498&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bcbeb498"]])

export default __exports__